"use strict";
/*
 * Created on 09 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var ProductEANConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductEANConverter, _DataObjectConverter_);

  function ProductEANConverter() {
    _classCallCheck(this, ProductEANConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductEANConverter).apply(this, arguments));
  }

  return ProductEANConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductEANConverter = ProductEANConverter;